<template>
    <div class="row mt-6" v-loading="loading">
        <div class="col-md-8 offset-md-2">
            <h3 class="text-mutted font-weight-bold pb-4 border-bottom">{{currentAcreditation.athlete}}</h3>
            <div class="row">
                <div class="col-sm-6">
                    <el-upload
                        class="avatar-uploader"
                        :headers="headers"
                        name="file"
                        :action="`${imageUrl}/api/photo/upload`"
                        accept=".jpg,.png"
                        :limit="1"
                        :data="photo"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="handleAvatarSuccess"
                        :on-error="handleAvatarError">
                        <img v-if="photo.idphoto !=null" :src="photo.ruta" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
                <div class="col-sm-6">
                    <div class="alert alert-custom alert-light-success fade show py-2" role="alert">
                        <div class="alert-icon"><i class="el-icon-message-solid icon-2x"></i></div>
                        <div class="alert-text" v-text="'Especificaciones'"></div>
                    </div>
                    <ul class="pl-6 text-left">
                        <li>Foto tamaño carnet</li>
                        <li>Fondo blanco</li>
                        <li>Formato *.png | *jpg</li>
                        <li>Peso máximo 500 Kb</li>
                    </ul>
                    <div class="alert alert-custom alert-light-success fade show py-2" role="alert">
                        <div class="alert-icon"><i class="el-icon-message-solid icon-2x"></i></div>
                        <div class="alert-text" v-text="'Nota'"></div>
                    </div>
                    <p>Si desea cambiar la fotografía, clic encima de la imágen</p>
                </div>
            </div>

        </div>
        <div class="col-sm-12">
            <el-divider class="my-4"></el-divider>
            <div class="d-flex justify-content-end" v-if="modalEdit">
                <div class="btn btn-sm btn btn-light" @click="cancelEdit"><i class="el-icon-close"></i> Cerrar</div>
            </div>
            <div class="d-flex justify-content-end" v-else>
                <div class="btn btn-sm btn-secondary mr-3" @click="cancelProcess"><i class="el-icon-close"></i> Cancelar</div>
                <div class="btn btn-sm btn-success"  @click="submitPhoto">Siguiente <i class="el-icon-arrow-right pr-0"></i></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { STEP, MODAL_NEW, MODAL_EDIT } from "@/store/step.module";

//services
import JwtService from "@/core/services/jwt.service";
import { athleteService, athleteError } from "@/core/services/athlete.service";
import code from "@/core/config/status.code";


export default {
    props: {
        photoData: {
        type: Object,
        default: () => {}
        },
    },
    data: () => ({
        loading: false,
        imageUrl: '',
        photo:{idperson:null, idphoto:null, ruta:''},
        headers:{Authorization: `Bearer ${JwtService.getToken()}`},

    }),
    computed: {
        ...mapGetters([ "currentAcreditation", "modalEdit" ])
    },
    beforeMount(){
        if(this.modalEdit){
            return this.photo = this.photoData;
        }else
            return this.photo.idperson = this.currentAcreditation.idperson;
    },
    methods:{
        cancelProcess(){
            this.$store.dispatch(MODAL_NEW, false);
        },
        cancelEdit(){
            this.$store.dispatch(MODAL_EDIT, false);
        },
        handleAvatarSuccess(res, file) {
            this.photo.idphoto = res.id
            this.photo.ruta = URL.createObjectURL(file.raw);
            this.currentAcreditation.idphoto = res.id
            this.$message({message: res.message,type: 'success'});
        },
        handleAvatarError(err, file){
            const e = JSON.parse(err.message);
            this.$alert(  e.messages.error, 'Error ' +  e.error, {type: 'warning'});
        },
        submitPhoto(){
            //console.log(this.currentAcreditation);
            if(this.currentAcreditation.idperson == null || this.currentAcreditation.idphoto ==null )
                return this.$notify.error({title: 'Alerta', message: 'La información no se a guardado de manera correcta, presione F5 y vuelva a intentarlo.'});
            this.$store.dispatch(STEP, 2).then();
        },
        updatePhoto(){

        },
        beforeAvatarUpload(file) {
            const isIMAGE = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg');
            //console.log(isIMAGE);
            /*if(this.photo.idperson == null || this.photo.idperson ==''){
                this.$notify.error({title: 'Campos vacios', message: 'Falta seleccionar el tipo de archivo a subir'});
                return false;
            }*/
            if (!isIMAGE) {
                this.$message.error('Only upload jpg/png picture!');
                return false;
            }
            return true;
        },
        async getPhoto(){
            try {
                this.loading = true
                const res = await athleteService.currentPhoto(this.currentAcreditation);
                this.photo = res.data;
                if (this.photo.idphoto !=null) this.currentAcreditation.idphoto = this.photo.idphoto;
                this.loading = false;
            } catch (e) {
                this.loading = false;
                if (e instanceof athleteError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }

        }
    },
    created(){
        this.imageUrl = process.env.VUE_APP_URL_BACKEND
        console.log(this.imageUrl);
        if(!this.modalEdit){
            this.getPhoto();
        }
    }
}
</script>